import { useEffect, useState } from 'react'
import { debug, logError } from 'lib/logging'

export function useDeferredData<T>(promise?: Promise<T> | null): T | undefined {
  let [data, setData] = useState<T | undefined>(undefined)
  useEffect(() => {
    const getData = async () => {
      let d = await promise
      debug(`defer`, `got data`, d)
      if (d) setData(d)
    }
    getData().catch((e) => {
      logError(`error getting deferred data`, e)
      // document.location = `/`
    })
  }, [promise])
  return data
}

export function useDeferredDataWithError<T>(promise?: Promise<T> | null): { data: T | undefined; error: Error | null } {
  const [data, setData] = useState<T | undefined>(undefined)
  const [error, setError] = useState<Error | null>(null)
  useEffect(() => {
    setError(null)
    const getData = async () => {
      let d = await promise
      debug(`defer`, `got data`, d)
      if (d) setData(d)
    }
    getData().catch((e) => {
      logError(`error getting deferred data`, e)
      setError(e)
    })
  }, [promise])
  return { data, error }
}
